<div class="max-w-xl mx-auto">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
    class="flex items-center justify-between">
    <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">assignment_add</mat-icon>
      Asignación de Transacción
    </h2>
    <button type="button" (click)="cancelar()"
      style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="p-5">
    <!-- Datos de la transacción -->
    <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin-bottom: 12px;">Datos de la transacción</h3>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 mb-5">
      <div *ngFor="let field of formFields" class="py-1">
        <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">{{ formTitles[field.name] }}</span>
        <p class="text-gray-700 text-sm font-medium mt-0.5">{{ field.value }}</p>
      </div>
    </div>

    <!-- Formulario asignación -->
    <form [formGroup]="datosForm" *ngIf="datosForm" (ngSubmit)="submitForm()"
      class="border-t border-gray-100 pt-4">
      <mat-form-field appearance="outline" class="modern-field w-full">
        <mat-label>ID del Usuario</mat-label>
        <input matInput type="text" formControlName="userId" placeholder="Ingrese el ID del usuario">
      </mat-form-field>
      <div *ngIf="datosForm.get('userId')?.hasError('onlyNumbers') && datosForm.get('userId')?.touched" class="text-red-500 text-xs -mt-2 mb-2">
        El ID de usuario debe contener solo números
      </div>
      <div *ngIf="datosForm.get('userId')?.hasError('required') && datosForm.get('userId')?.touched" class="text-red-500 text-xs -mt-2 mb-2">
        Ingrese un ID de usuario válido
      </div>

      <div class="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
        <button type="submit" [disabled]="datosForm!.invalid"
          [style.opacity]="datosForm!.invalid ? '0.5' : '1'"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
          Enviar datos
        </button>
        <button type="button" (click)="cancelar()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">close</mat-icon>
          Cerrar
        </button>
      </div>
    </form>
  </div>
</div>
